import { render, staticRenderFns } from "./partnersLayout.vue?vue&type=template&id=1cbda6f7"
import script from "./partnersLayout.vue?vue&type=script&lang=js"
export * from "./partnersLayout.vue?vue&type=script&lang=js"
import style0 from "./partnersLayout.vue?vue&type=style&index=0&id=1cbda6f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsFooterPartnersComponent: require('/usr/src/app/components/layouts/FooterPartnersComponent.vue').default})
